<div class="wrapper">
  <h1 class="margin-bottom">{{ message }}</h1>
  <h3 *ngIf="needConfirmation" class="margin-bottom">Cette action est irréversible</h3>
  <app-button *ngIf="needConfirmation" [outline]="true" (click)="confirm()">Confimer</app-button>
</div>
